import { useEffect } from "react";

const useIdleTimer = (onIdle, timeout = 10 * 60 * 1000) => {
  useEffect(() => {
    let idleTimer;

    const resetTimer = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(onIdle, timeout);
    };

    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    events.forEach(event =>
      window.addEventListener(event, resetTimer)
    );

    resetTimer(); // start timer

    return () => {
      clearTimeout(idleTimer);
      events.forEach(event =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, [onIdle, timeout]);
};

export default useIdleTimer;
